/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import o from "prop-types";
import { classNames as n } from "@progress/kendo-react-common";
import { cardActionsLayout as i, cardOrientation as a } from "./interfaces/Enums.mjs";
const s = (r) => {
  const t = {
    layout: i.START,
    orientation: a.HORIZONTAL,
    ...r
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      style: t.style,
      className: n(
        "k-card-actions",
        "k-actions",
        t.className,
        `k-actions-${t.layout}`,
        t.orientation !== a.VERTICAL ? "k-actions-horizontal" : "k-actions-vertical"
      )
    },
    t.children
  );
};
s.propTypes = {
  layout: o.oneOf(["stretched", "start", "center", "end"]),
  orientation: o.oneOf(["horizontal", "vertical"])
};
export {
  s as CardActions
};
